/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
import _ from 'lodash';
import Immutable from 'immutable';
import {
  UPDATE_COURSES,
  START_SET_COURSE_OBJECTIVE_AND_OUTCOMES,
  FINISH_SET_COURSE_OBJECTIVE_AND_OUTCOMES,
  FETCH_COURSE_OUTCOMES,
  RETRIEVE_COURSE_OUTCOMES,
  COURSE_ADD_ADMIN,
  SET_COURSE_LANDING_PAGE_DATA,
} from './actions';
import {
  COURSES_FETCH_SUCCESS,
  COURSES_LOAD_SUCCESS,
  COURSES_FREE_FETCH_SUCCESS,
  COURSES_FREE_LOAD_SUCCESS,
  COURSES_PAID_FETCH_SUCCESS,
  COURSES_PAID_LOAD_SUCCESS,
  COURSES_FEATURED_FETCH_SUCCESS,
  COURSES_FEATURED_LOAD_SUCCESS,
} from '../Courses/CoursesList/actions';
import { FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_SUCCESS } from '../InstitutionAdminUI/actions';
import {
  NOTIFICATION_READ_FETCH_SUCCESS,
  NOTIFICATION_READ_REFRESH_SUCCESS,
  NOTIFICATION_READ_LOAD_MORE_SUCCESS,
  NOTIFICATION_UNREAD_FETCH_SUCCESS,
  NOTIFICATION_UNREAD_REFRESH_SUCCESS,
  NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS,
} from '../Notifications/actions';
import { LOGOUT_SUCCESS, UPDATE_ENROLLED_CLASS_DATA } from '../Auth/actions';
import { PORTFOLIO_QUERY_COMPLETE } from '../Galleries/actions';
import { COURSE_NAVIGATION_DATA_SET } from '../CourseNavigationInfo/actions';
import { FETCH_NOTIFICATION_DETAIL_SUCCESS } from '../PushNotification/actions';
import { FETCH_COURSE_ROLES_DATA_SUCCESS } from '../CourseAdmin/actions';
import { WASABI_FETCH_USER_COURSES_SUCCESS } from '../Wasabi/actions';
import {
  FETCH_INSTITUTION_STUDENT_DATA_SUCCESS,
  FETCH_INSTITUTION_STUDENT_DATA_FAILURE,
} from '../InstitutionAdminUI/StudentData/actions';

export function Courses(state = Immutable.Map(), action) {
  const getCourse = (coursePath) => {
    if (state.has(coursePath)) {
      return state.get(coursePath);
    }
    return Immutable.Map({
      objective: '',
      outcomes: [],
    });
  };

  switch (action.type) {
    case UPDATE_COURSES:
    case FETCH_COURSE_ROLES_DATA_SUCCESS:
    case UPDATE_ENROLLED_CLASS_DATA:
    case COURSE_NAVIGATION_DATA_SET:
    case PORTFOLIO_QUERY_COMPLETE:
    case NOTIFICATION_READ_FETCH_SUCCESS:
    case NOTIFICATION_READ_REFRESH_SUCCESS:
    case NOTIFICATION_READ_LOAD_MORE_SUCCESS:
    case NOTIFICATION_UNREAD_FETCH_SUCCESS:
    case NOTIFICATION_UNREAD_REFRESH_SUCCESS:
    case NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS:
    case FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_SUCCESS:
    case FETCH_NOTIFICATION_DETAIL_SUCCESS: {
      let newState = state;
      _.forEach(action.courses, (course) => {
        newState = newState.set(course.path, Immutable.fromJS(course));
        newState = newState.setIn([course.path, 'isSaving'], false);
      });
      return newState;
    }
    case COURSES_FETCH_SUCCESS:
    case COURSES_LOAD_SUCCESS:
    case COURSES_FREE_FETCH_SUCCESS:
    case COURSES_FREE_LOAD_SUCCESS:
    case COURSES_PAID_FETCH_SUCCESS:
    case COURSES_PAID_LOAD_SUCCESS:
    case COURSES_FEATURED_FETCH_SUCCESS:
    case COURSES_FEATURED_LOAD_SUCCESS: {
      let newState = state;
      _.forEach(action.coursesData, (course) => {
        newState = newState.set(course.path, Immutable.fromJS(course));
      });
      return newState;
    }
    case COURSE_ADD_ADMIN: {
      const { coursePath, admins } = action;
      if (state.has(coursePath)) {
        return state.setIn([coursePath, 'admins'], Immutable.fromJS(admins));
      }
      return state;
    }
    case START_SET_COURSE_OBJECTIVE_AND_OUTCOMES:
    case FINISH_SET_COURSE_OBJECTIVE_AND_OUTCOMES: {
      const { coursePath, objective, outcomes, type } = action;
      let course = getCourse(coursePath);
      course = course.set('objective', objective);
      course = course.set('outcomes', Immutable.fromJS(outcomes));
      course = course.set(
        'isSaving',
        type === START_SET_COURSE_OBJECTIVE_AND_OUTCOMES
      );
      return state.set(coursePath, course);
    }
    case FETCH_COURSE_OUTCOMES:
    case RETRIEVE_COURSE_OUTCOMES: {
      const { coursePath, outcomes, type } = action;
      let course = getCourse(coursePath);
      course = course.set('outcomes', Immutable.fromJS(outcomes));
      course = course.set('isFetching', FETCH_COURSE_OUTCOMES === type);
      return state.set(coursePath, course);
    }
    case SET_COURSE_LANDING_PAGE_DATA: {
      const { course } = action;
      return state.mergeIn([course.path], Immutable.fromJS(course));
    }
    case WASABI_FETCH_USER_COURSES_SUCCESS: {
      const { courses } = action;
      const results = Immutable.fromJS(courses);
      return results
        .valueSeq()
        .reduce(
          (newState, item) => newState.set(item.get('path'), item),
          state
        );
    }
    case FETCH_INSTITUTION_STUDENT_DATA_SUCCESS:
    case FETCH_INSTITUTION_STUDENT_DATA_FAILURE: {
      const { course } = action;
      if (course) {
        return state.set(course.get('path'), course);
      }
      return state;
    }
    case LOGOUT_SUCCESS: {
      return Immutable.Map();
    }
    default: {
      return state;
    }
  }
}
